import React from "react";
import { DateInput, TimePicker } from '@mantine/dates';
import { GenericFieldProps } from "src/utils/forms";
import { useAppState } from "src/state";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

export const DateTimePickerInput: React.FC<GenericFieldProps> = ({
    id,
    name,
    label,
    onChange,
    onBlur,
    value: incomingValue,
    error,
    required,
    disabled,
    classNames
}) => {

    const { currentItem: currentlySelectedUser } = useAppState(state => state.users)
    const currentUser = useAppState(state => state.profile)

    const [date, setDate] = React.useState<string | undefined | null>();
    const [time, setTime] = React.useState<string | undefined>();

    let tz = currentlySelectedUser?.timezone || currentUser?.timezone || 'America/New_York';

    React.useEffect(() => {
        if (incomingValue) {
          const local = dayjs.utc(incomingValue).tz(tz);    
          setDate(local.format("YYYY-MM-DD"));
          setTime(local.format("HH:mm"));
        }
      }, [incomingValue, tz]);

    React.useEffect(() => {
        if (date && date.length && time && time.length) {
            const combinedStr = `${date} ${time}`
            const localDateTime = dayjs.tz(combinedStr, "YYYY-MM-DD HH:mm", tz)
            const isoString = localDateTime.toISOString()
            onChange(isoString)
        } else {
            onChange(null)
        }
    }, [date, time, currentlySelectedUser, currentUser])

    return (
        <div>
            <DateInput
                id={id}
                name={name}
                label={`${label} Date`}
                value={date}
                error={error}
                required={required}
                disabled={disabled}
                onChange={setDate}
                onBlur={onBlur}
                classNames={classNames}
                clearable
                mb="xs"
            />
            <TimePicker
                id={`${id}-time`}
                name={`${name}-time`}
                label={`${label} Time`}
                withSeconds={false}
                value={time}
                onChange={setTime}
                onBlur={onBlur}
                error={error}
                required={required}
                disabled={disabled}
                withDropdown
                format="12h"
                classNames={classNames}
            />
        </div>
    )
}